import React from 'react';

const GlobalSpinner = () => {
    const styles = {
        wrapper: {
            height: '100vh',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            background: '#f0f0f0',
        },
        spinner: {
            width: '50px',
            height: '50px',
            border: '5px solid #ccc',
            borderTop: '5px solid #333',
            borderRadius: '50%',
            animation: 'spin 1s linear infinite',
        },
        keyframes: `
          @keyframes spin {
            to { transform: rotate(360deg); }
          }
        `,
    };

    return <>
        <style>{styles.keyframes}</style>
        <div style={styles.wrapper}>
            <div style={styles.spinner}></div>
        </div>
    </>
}

export default GlobalSpinner
